import { analyticsUtils } from 'utils/analytics-utils';

/**
 * Событие должно срабатывать при клике на кнопку "Указать размеры" в разделе "Двери и окна".
 * ИЛИ
 * Событие должно срабатывать при клике на кнопку "Добавить/удалить дверь/окно" в разделе "Двери и окна".
 *  ИЛИ
 * Событие должно срабатывать при клике на кнопку "Указать размеры / Указать площадь" в разделе "Параметры помещения".
 */

export const gaClickOnGoods = ({ title, name }: { title: string; name: string }) =>
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'productDetail / calc', // блок, в котором расположен элемент
    elementName: title, // название заголовка
    elementText: name, // название кнопки
  });
